/**
 * Free of runtime imports, so any module can use it without a cycle. Nothing
 * here is a default: the chain comes from the descriptor, its facts from
 * `chains.json`.
 */

import type { ChainEntry, NativeCurrency } from "./chainSelect";

/** 8453 -> "0x2105" (the form the wallet RPCs expect). */
export function toChainIdHex(chainId: number): string {
  return `0x${chainId.toString(16)}`;
}

export interface AddChainParams {
  chainId: string;
  chainName: string;
  nativeCurrency: NativeCurrency;
  rpcUrls: string[];
  blockExplorerUrls?: string[];
}

/**
 * EIP-3085 `wallet_addEthereumChain` parameters from the network's directory
 * entry, or null when it lacks a fact the wallet needs.
 */
export function addChainParams(entry: ChainEntry): AddChainParams | null {
  const { chainId, nativeCurrency, walletRpcUrls, explorer } = entry;
  if (chainId === undefined || nativeCurrency === undefined) return null;
  if (walletRpcUrls === undefined || walletRpcUrls.length === 0) return null;
  return {
    chainId: toChainIdHex(chainId),
    chainName: entry.label,
    nativeCurrency,
    rpcUrls: walletRpcUrls,
    ...(explorer ? { blockExplorerUrls: [explorer.url] } : {}),
  };
}
